import { gql } from "@apollo/client";

export const QUERY_SAVED_LOAD_LIST = gql`
  query UserSavedLoads {
    userSavedLoads {
      id
      originAddress
      originCountry
      originCity
      originState
      originZip
      destinationAddress
      destinationCountry
      destinationCity
      destinationState
      destinationZip
      trailerType
      length
      targetRate
      weight
      timeStart
      timeEnd
      timeDelivery
      details
      timePosted
      userId
      userType
      isDeleted
      debtor
      status
      assignedUser
      cargoValue
      userLoadNumber
      originLocations {
        name
        streetOne
        city
        state
        country
        zip
        instructions
      }
      destinationLocations {
        name
        streetOne
        city
        state
        country
        zip
        instructions
      }
      user {
        id
        email
        userType
        contactName
        contactEmail
        address
        city
        state
        country
        contactPhone
        mc
        dot
      }
      linehaul {
        linehaulCpg
        averageRate
      }
    }
  }
`;

export const MUTATION_DELETE_SAVED_LOAD = gql`
  mutation DeleteUserSavedLoad($loadId: UUID!) {
    deleteUserSavedLoad(loadId: $loadId) {
      success
    }
  }
`;
